import { IonText, IonIcon } from '@ionic/react'
import { chevronBackOutline } from 'ionicons/icons'
import { useEffect, useRef } from 'react'
import { useHistory } from 'react-router'
import Chart from 'chart.js/auto'
import dayjs from 'dayjs'
import { NoRecords } from '../../components/NoRecords'

const MeasueresNames = [
	'Peso corporeo',
	'Circonferenza collo',
	'Circonferenza ombelicale',
	'Circonferenza fianchi',
	'Circonferenza coscia',
	'Circonferenza braccio',
]

const measureOptions = {
	maintainAspectRatio: false,
	aspectRatio: 0.6,
	plugins: {
		legend: {
			display: false,
			labels: {
				color: '#495057',
			},
		},
	},
	scales: {
		x: {
			ticks: {
				color: '#495057',
			},
			grid: {
				color: '#ebedef',
			},
		},
		y: {
			ticks: {
				color: '#495057',
			},
			grid: {
				color: '#ebedef',
			},
		},
	},
}

const measureData = {
	labels: [],
	datasets: [
		{
			sufix: 'kg',
			data: [],
			fill: false,
			borderColor: '#6366f1',
			tension: 0.4,
		},
	],
}

const DiarioContentSpecific = ({ measureTitle = '', measures = [] }) => {
	const chartRef = useRef(null)
	const history = useHistory()
	const title = MeasueresNames.includes(measureTitle)
		? measureTitle
		: MeasueresNames[0]
	measureData.datasets[0].label = title
	const measure = measures.find((measure) => measure.title === title)

	const hasData =
		measure &&
		Array.isArray(measure.labels) &&
		Array.isArray(measure.values) &&
		measure.labels.length > 0

	useEffect(() => {
		// Destroy previous chart if exists
		if (chartRef.current) {
			chartRef.current.destroy()
			chartRef.current = null
		}

		if (!measure || !hasData) {
			return
		}

		const formattedLabels = measure.labels.map((date) =>
			dayjs(date).format('DD/MM/YY')
		)

		measureData.datasets[0].data = [...measure.values]
		measureData.labels = formattedLabels

		chartRef.current = new Chart(
			document.getElementById('measure-chart'),
			{
				type: 'line',
				data: measureData,
				options: measureOptions,
			}
		)
		// Cleanup on unmount
		return () => {
			if (chartRef.current) {
				chartRef.current.destroy()
				chartRef.current = null
			}
		}
		// Recalcular cuando cambian las misure o il titolo selezionato
	}, [measures, title])

	const handleBackToList = () => {
		const url = new URL(window.location.href)
		url.searchParams.delete('measure')
		history.replace(url.pathname + url.search)
	}

	return (
		<>
			<div
				className="ion-text-center ion-padding-horizontal"
				style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					gap: '0.5rem',
				}}>
				<IonIcon
					icon={chevronBackOutline}
					onClick={handleBackToList}
					style={{ fontSize: '20px', cursor: 'pointer' }}
				/>
				<h4 style={{ margin: 0 }}>{title}</h4>
			</div>

			{!hasData ? (
				<NoRecords text="misure" />
			) : (
				<div
					style={{
						height: '300px',
						maxHeight: '300px',
						padding: '0 1rem',
					}}>
					<canvas
						id="measure-chart"
						style={{ height: '100%', width: '100%' }}
					/>
				</div>
			)}
		</>
	)
}

export default DiarioContentSpecific
